@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.calls

import com.narbase.letsgo.router.EndPoint

object StartVoipCallEndpoint : EndPoint<StartVoipCallEndpoint.Request, StartVoipCallEndpoint.Response>() {
    class Request()
    class Response(
        val credentials: VoipCallCredentialsDto?
    )
}
